import { getCountryFlag } from '../../utils/helper';
import { Wallet } from '../../interfaces/Wallet';
import { useEffect, useState } from 'react';
import { queryConfig } from '../../api/queryBase';

const useWallets = () => {
    const [wallets, setWallets] = useState<Wallet[]>([]);
    const query = queryConfig();
    const { isLoading, data, refetch } = query<Wallet[]>({
        url: '/wallets',
        cacheKey: 'wallets'
    });

    useEffect(() => {
        const unsorted = (data?.payload || []).map((wallet) => ({
            ...wallet,
            nameAndFlag: `${getCountryFlag(wallet.currency)?.flag} ${
                wallet.currency
            }`,
            country: `${getCountryFlag(wallet.currency)?.country}`
        }));

        setWallets(
            unsorted.sort(
                (a, b) => Number(b.ledgerBalance) - Number(a.ledgerBalance)
            )
        );
    }, [isLoading]);

    return { isLoading, wallets, refetch };
};

export default useWallets;
